import React from 'react';
import { useNavigate } from 'react-router-dom';

const BumdesBmc = () => {
  const navigate = useNavigate();

  return (
    <div className='container py-5'>
      <div className='row justify-content-center'>
        <div className='col-lg-8 text-center'>
          <div className='card border-0 shadow-sm rounded-4 p-5 bg-white position-relative overflow-hidden'>
            {/* Soft decorative background circles */}
            <div
              className='position-absolute rounded-circle bg-primary bg-opacity-10'
              style={{
                width: '120px',
                height: '120px',
                top: '-40px',
                right: '-40px',
              }}
            ></div>
            <div
              className='position-absolute rounded-circle bg-success bg-opacity-10'
              style={{
                width: '100px',
                height: '100px',
                bottom: '-30px',
                left: '-30px',
              }}
            ></div>

            <div className='position-relative z-1'>
              {/* Premium Blueprint/Design Icon */}
              <div
                className='d-inline-flex align-items-center justify-content-center bg-light rounded-circle mb-4 shadow-sm border border-2 border-white'
                style={{ width: '90px', height: '90px' }}
              >
                <i className='bi bi-grid-3x3-gap-fill text-primary display-4'></i>
              </div>

              <h2 className='fw-bold text-dark mb-2'>
                Modul Business Model Canvas (BMC) Sedang Dipersiapkan
              </h2>
              <p
                className='text-muted mx-auto mb-4'
                style={{
                  maxWidth: '600px',
                  fontSize: '1.05rem',
                  lineHeight: '1.6',
                }}
              >
                Kami sedang menyelaraskan instrumen pemetaan strategi bisnis
                BUMDes ini agar terintegrasi secara langsung dengan hasil
                rekomendasi asesmen daya saing (VECI T0) Anda. Fitur ini akan
                otomatis diaktifkan setelah klasifikasi program Anda
                diverifikasi oleh tim pendamping.
              </p>

              {/* Development Roadmap Indicator */}
              <div
                className='card bg-light border-0 rounded-4 p-4 mb-4 text-start mx-auto'
                style={{ maxWidth: '500px' }}
              >
                <h6 className='fw-bold text-secondary mb-3 uppercase-tracking extra-small'>
                  TAHAPAN ALUR HINGGA BMC TERBUKA
                </h6>
                <div className='d-flex align-items-start mb-3'>
                  <div
                    className='bg-success text-white rounded-circle d-flex align-items-center justify-content-center me-3 flex-shrink-0'
                    style={{
                      width: '24px',
                      height: '24px',
                      fontSize: '0.8rem',
                    }}
                  >
                    <i className='bi bi-check'></i>
                  </div>
                  <div>
                    <p className='mb-0 fw-semibold text-dark small'>
                      Pre-Survey & Kesiapan Program
                    </p>
                    <p className='mb-0 text-muted extra-small'>
                      Mengisi kesediaan komitmen BUMDes.
                    </p>
                  </div>
                </div>
                <div className='d-flex align-items-start mb-3'>
                  <div
                    className='bg-success text-white rounded-circle d-flex align-items-center justify-content-center me-3 flex-shrink-0'
                    style={{
                      width: '24px',
                      height: '24px',
                      fontSize: '0.8rem',
                    }}
                  >
                    <i className='bi bi-check'></i>
                  </div>
                  <div>
                    <p className='mb-0 fw-semibold text-dark small'>
                      Pengisian Survei VECI
                    </p>
                    <p className='mb-0 text-muted extra-small'>
                      Menganalisis kapasitas ekonomi dan daya saing BUMDes saat
                      ini.
                    </p>
                  </div>
                </div>
                <div className='d-flex align-items-start'>
                  <div
                    className='bg-primary text-white rounded-circle d-flex align-items-center justify-content-center me-3 flex-shrink-0 animate-pulse'
                    style={{
                      width: '24px',
                      height: '24px',
                      fontSize: '0.8rem',
                      fontWeight: 'bold',
                    }}
                  >
                    3
                  </div>
                  <div>
                    <p className='mb-0 fw-semibold text-primary small'>
                      Klasifikasi Jalur Program & Akses BMC
                    </p>
                    <p className='mb-0 text-muted extra-small'>
                      Penetapan jalur pemberdayaan dan penyusunan strategi
                      bisnis (BMC).
                    </p>
                  </div>
                </div>
              </div>

              {/* Action Buttons */}
              <div className='d-flex justify-content-center gap-3'>
                <button
                  onClick={() => navigate('/bumdes')}
                  className='btn btn-primary rounded-pill px-4 py-2.5 fw-bold shadow-sm'
                >
                  <i className='bi bi-house-door me-2'></i> Kembali ke Dashboard
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        .extra-small {
          font-size: 0.75rem;
          letter-spacing: 0.05em;
        }
        .animate-pulse {
          animation: pulse 2s infinite;
        }
        @keyframes pulse {
          0%, 100% {
            opacity: 1;
            transform: scale(1);
          }
          50% {
            opacity: .6;
            transform: scale(1.05);
          }
        }
      `}</style>
    </div>
  );
};

export default BumdesBmc;
